import { render, staticRenderFns } from "./examRecord.vue?vue&type=template&id=209d7c9e&scoped=true&"
import script from "./examRecord.vue?vue&type=script&lang=js&"
export * from "./examRecord.vue?vue&type=script&lang=js&"
import style0 from "./examRecord.vue?vue&type=style&index=0&id=209d7c9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209d7c9e",
  null
  
)

export default component.exports